export default __webpack_public_path__ + "static/media/cave.95fda2e4.jpg";